import { render, staticRenderFns } from "./iconP8.vue?vue&type=template&id=1168b292&scoped=true&"
import script from "./iconP8.vue?vue&type=script&lang=js&"
export * from "./iconP8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1168b292",
  null
  
)

export default component.exports